import React, { useState, useEffect } from "react";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button as ComponentButton,
} from "../../../components/Component";

import { useSelector } from "react-redux";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { Button, Card } from "reactstrap";
import { useNavigate } from "react-router";
type TabType = {
  label: string;
  tabKey: string;
  content?: any;
};
type Props = {
  header?: {
    title: string;
    titleContent?: React.ReactNode;
    subComponents?: React.ReactNode[];
    subComponentPosition?: "bottom" | "right";
    previousPageLink?: string;
    previousPageTitle?: string;
    previousPageIcon?: string;
  };
  body: {
    refreshOptions?: {
      enabled: boolean;
      refresh: boolean;
      onRefresh: any;
    };
    hideTabTitles?: boolean;
    tabOptions: {
      tab: string;
      setTab: any;
      tabs: TabType[];
    };
  };
};
const InDetailView = ({ header, body }: Props) => {
  const navigate = useNavigate();
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const allSites: any = [];
        const _siteOptions: any = [];
        siteAccessibility?.forEach((item: any) => {
          allSites.push(item.siteID);
          _siteOptions.push({ label: item.siteName, value: item.siteID });
        });
      }
    }
  }, [currentUser]);
  const { tabOptions, refreshOptions, hideTabTitles } = body;
  const TabsList = tabOptions?.tabs;

  return (
    <React.Fragment>
      <Head title={header?.title} />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className="card-inner card-inner-lg pt-1"
              style={{ minHeight: "75vh" }}
            >
              {header?.title && (
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent className="d-flex align-items-center">
                      {header?.titleContent}
                      <div
                        className={`${
                          header?.subComponentPosition == "right"
                            ? "d-flex align-center"
                            : ""
                        }`}
                      >
                        <BlockTitle tag="h4" className="m-0">
                          <span>{header?.title}</span>
                        </BlockTitle>
                        <div
                          className={`content d-flex align-center clearfix ${
                            header?.subComponentPosition == "right" && "ms-2"
                          }`}
                        >
                          {header?.subComponents}
                        </div>
                      </div>
                    </BlockHeadContent>
                    <div className="actions clearfix ">
                      <ul
                        className="m-auto d-flex align-items-center justify-content-center p-0 position-relative"
                        style={{
                          flexDirection: "row-reverse",
                        }}
                      >
                        {header?.previousPageLink && (
                          <li className="pt-0 pb-0">
                            <Button
                              className="toggle"
                              color="primary"
                              size="sm"
                              onClick={() => {
                                navigate(header?.previousPageLink || "");
                              }}
                            >
                              <Icon
                                name={header?.previousPageIcon || "arrow-left"}
                              />
                              <span>{header?.previousPageTitle || "Back"}</span>
                            </Button>
                          </li>
                        )}
                      </ul>
                    </div>
                  </BlockBetween>
                </BlockHead>
              )}
              {/* Tabs start here */}
              {TabsList?.length > 0 && (
                <div className="d-flex align-items-center flex-wrap mb-2">
                  {!hideTabTitles && (
                    <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative ">
                      {TabsList?.map((_tab: any, index: number) => {
                        return (
                          <li
                            className="nav-item"
                            key={_tab?.tabKey}
                            onClick={() =>
                              tabOptions?.setTab(() => _tab?.tabKey)
                            }
                          >
                            <a
                              onClick={(ev) => {
                                ev.preventDefault();
                              }}
                              className={`nav-link${
                                tabOptions?.tab === _tab?.tabKey
                                  ? " active"
                                  : ""
                              }`}
                              href={"#" + _tab?.tabKey}
                            >
                              {_tab?.label}
                            </a>
                          </li>
                        );
                      })}
                      {/* <li className="nav-item nav-item-trigger d-xxl-none">
                      <ComponentButton
                        className={`toggle btn-icon btn-trigger`}
                        onClick={() => {
                          setModalOpen(true);
                        }}
                      >
                        <Icon name="user-list-fill"></Icon>
                      </ComponentButton>
                    </li> */}
                      {/* {refreshOptions?.enabled && (
                      <span
                        className="btn btn-white btn-outline-light btn-sm cursor-pointer position-absolute"
                        style={{
                          right: 7,
                          top: 15.5,
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          refreshOptions?.onRefresh(!refreshOptions?.refresh);
                        }}
                      >
                        <Icon name="reload" />
                        <span>Refresh</span>
                      </span>
                    )} */}
                    </ul>
                  )}
                  <div className="tab-content mt-0 w-100">
                    {TabsList?.map((_tab) => {
                      return (
                        <div
                          key={_tab?.tabKey}
                          className={`tab-pane${
                            tabOptions?.tab === _tab?.tabKey ? " active" : " "
                          }`}
                        >
                          {tabOptions?.tab === _tab?.tabKey ? (
                            _tab?.content
                          ) : (
                            <></>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* Tabs end here */}
          </div>
        </Card>
      </Content>
    </React.Fragment>
  );
};

export default InDetailView;
